import { Injectable } from '@angular/core';
import { ServerToClientEvents } from '@reflact/ipkv-types';
import { waitSeconds } from '@reflact/tsutil';
import { io, Socket } from 'socket.io-client';
import { UsertokenService } from '../usertoken.service';
import { Subject } from 'rxjs';

type ClientToServerEvents = {}
export type MySocket = Socket<ServerToClientEvents, ClientToServerEvents>;



@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private ioSocket?: MySocket;
  public = new Subject()

  public disconnectionSubject: Subject<string> = new Subject()

  constructor(
    private usertokenService: UsertokenService
  ) { }

  public async getIo(): Promise<MySocket> {
    if (this.ioSocket) {
      return this.ioSocket;
    }
    await waitSeconds(0.2);
    return this.getIo();
  }


  public disconnectionHandler(msg: string) {
    this.disconnectionSubject.next(msg);
  }

  protected createSocket(): MySocket {
    return io({
      autoConnect: true,
      transports: ["polling", "websocket"],
      query: {
        pkvut: "" + this.usertokenService.getUserToken(),
      },
      reconnection: false,
      withCredentials: true
    });
  }

  public connect(): Promise<MySocket> {
    return new Promise((resolve, reject) => {
      if (this.ioSocket != null) {
        resolve(this.ioSocket);
        return;
      }
      try {
        this.ioSocket = this.createSocket();


        this.ioSocket.on("connect_error", (err) => {
          console.warn("Connect Error", err)
          this.disconnectionHandler("Verbindungsfehler")
          reject(err)
        })

        this.ioSocket.on("thereCanOnlyBeOne", () => {
          this.ioSocket?.removeAllListeners();
          this.disconnectionHandler("Die Sitzung wurde in einem anderen Fenster geöffnet. Sie können dieses Fenster nun schließen oder erneut verbinden.")
          this.ioSocket?.disconnect()
        });


        this.ioSocket.on("runUpdate", (item) => { console.log("RUNUPDATE", item) });
        this.ioSocket.on("runComplete", (item) => { console.log("RUNCOMPLETE", item) });
        this.ioSocket.on("stateUpdate", (state) => { console.log("STATEUDPATE", state) });

        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ioSocket.on('connect', () => {
          console.log("Socket Connected")
          resolve(this.ioSocket!)
        });
        this.ioSocket.on('disconnect', () => {
          console.log("Socket Disconnected")
          this.disconnectionHandler("Verbindung verloren (1).")
        });
      } catch (e) {
        this.disconnectionHandler("Verbindung verloren (2).");
        reject(e);
      }
    })
  }
}